import i18n from 'i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

// Developer needs to define a specific key & it's value in the traslation.json file in locale for respective language
i18n.use(Backend)
	// .use(LanguageDetector)
	.use(initReactI18next)
	.init({
		debug: true,
		lng: 'en',
		backend: {
			loadPath: '/locales/{{lng}}/{{ns}}.json', // adjust this to your backend URL
		},
	});
